var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Autocomplete as MuiAutocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import CheckBox from "../../components/CheckBox";
import { SelectorSize } from "@eightfold.ai/octuple";
import styles from "./Autocomplete.module.scss";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
export var AutocompleteOptionStyles = {
    backgroundColor: "inherit",
    borderRadius: "50px",
    marginTop: "5px",
    fontFamily: "var(--font-stack-full-book)",
    fontSize: "18px",
    color: "var(--grey-color-90)",
};
export var AutocompleteChipProps = {
    sx: {
        backgroundColor: "#e0f7fa",
        border: "1px solid var(--blue-color-70)",
        fontSize: "14px",
        color: "var(--grey-color-90)",
        borderRadius: "8px",
    },
    deleteIcon: _jsx(CloseOutlined, { className: styles.closeOutlined }),
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isPlainObject = function (value) {
    return Object.prototype.toString.call(value) === "[object Object]";
};
var Autocomplete = function (_a) {
    var options = _a.options, onSelect = _a.onSelect, label = _a.label, description = _a.description, resetTrigger = _a.resetTrigger, _b = _a.initialValue, initialValue = _b === void 0 ? [] : _b, disabled = _a.disabled, placeholder = _a.placeholder, isOptionEqualToValue = _a.isOptionEqualToValue;
    var _c = React.useState(initialValue || []), values = _c[0], setValues = _c[1];
    var filterOptions = useMemo(function () {
        return (options || [])
            .map(function (option) { return ({
            value: (option === null || option === void 0 ? void 0 : option.value) || option,
            label: (option === null || option === void 0 ? void 0 : option.label) ||
                (isPlainObject(option) ? option === null || option === void 0 ? void 0 : option.value : option) ||
                "",
        }); })
            .filter(function (option) { return option === null || option === void 0 ? void 0 : option.value; })
            .sort(function (_a, _b) {
            var a = _a.label;
            var b = _b.label;
            return (a > b ? 1 : -1);
        });
    }, [JSON.stringify(options)]);
    var valueKeys = (values === null || values === void 0 ? void 0 : values.map(function (value) { return (value === null || value === void 0 ? void 0 : value.value) || value; })) || [];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: styles.autocompleteMainContainer }, getAutomationTag(TestTag.AutocompleteField, label ? label.toLowerCase().replace(/\s+/g, "-") : "field"), { children: [_jsx("label", __assign({ className: styles.autocompleteLabel }, { children: label })), description && (_jsx("div", __assign({ className: styles.autocompleteDescription }, { children: description }))), _jsx(MuiAutocomplete, { multiple: true, options: filterOptions, "data-testid": "Autocomplete", limitTags: 2, onChange: function (event, newValue) {
                        onSelect(newValue);
                        setValues(newValue);
                    }, ListboxProps: {
                        onScroll: function (event) {
                            var listboxNode = event.currentTarget;
                            if (listboxNode.scrollTop === 0) {
                                console.log("Top of the list reached");
                            }
                        },
                    }, disablePortal: true, disableCloseOnSelect: true, sx: { padding: "8px 0" }, value: filterOptions.filter(function (option) {
                        return valueKeys.includes(option.value || option);
                    }), disabled: disabled, renderInput: function (params) {
                        var _a;
                        return (_jsx(TextField, __assign({}, params, { placeholder: placeholder
                                ? placeholder
                                : (values === null || values === void 0 ? void 0 : values.length) === 0 &&
                                    !((_a = params === null || params === void 0 ? void 0 : params.inputProps) === null || _a === void 0 ? void 0 : _a["aria-expanded"])
                                    ? "All"
                                    : "", sx: {
                                border: "1px solid var(--grey-color-60)",
                                borderRadius: "8px",
                                "& .MuiOutlinedInput-root": {
                                    padding: "0px 0px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "& .MuiOutlinedInput-notchedOutline legend": {
                                    border: "none",
                                },
                                backgroundColor: "var(--background-color)",
                            } })));
                    }, isOptionEqualToValue: isOptionEqualToValue ||
                        (function (option, value) { return option.value === value.value; }), renderOption: function (props, option, _a) {
                        var selected = _a.selected;
                        var key = props.key, optionProps = __rest(props, ["key"]);
                        return (_jsx("div", { children: _jsxs("li", __assign({}, optionProps, { style: AutocompleteOptionStyles }, { children: [_jsx("div", __assign({ style: { position: "relative", top: "-2px" } }, { children: _jsx(CheckBox, { size: SelectorSize.Medium, checked: function () { return !!selected; } }) })), _jsx("span", { children: option.label })] })) }, "".concat(key, "-").concat(option.value)));
                    }, ChipProps: AutocompleteChipProps })] }), resetTrigger) }));
};
export default Autocomplete;
